import { ColoredAvatar } from '@components/colored-elements';
import { HiLogout } from '@icon/react-icons';
import {
  IconButton,
  MenuItem,
  Box,
  Typography,
  Divider,
  Fade,
  ListItemIcon,
  withStyles,
  Popover,
  ListItemText,
} from '@material-ui/core';
import { orange, purple } from '@material-ui/core/colors';
import { useCallback, useState } from 'react';
import { token } from 'services/token';
import * as userService from 'services/user';
import styled from 'styled-components';

export const ProfileButton = () => {
  const [anchorEl, setAnchorEl] = useState(null);

  const openMenu = useCallback(evt => {
    setAnchorEl(evt.target);
  }, []);
  const closeMenu = useCallback(() => {
    setAnchorEl(null);
  }, []);
  const logout = useCallback(() => {
    token.logout();
    closeMenu();
  }, []);

  const { user } = userService.useUser();
  const first_name = user?.first_name || "";
  const last_name = user?.last_name || "";
  const designation = user?.designation || "";
  const organization = user?.organization || "";
  const roleId = user?.roleId || "";
  const avatarText = user ? (first_name?.[0] || '') + (last_name?.[0] || '') : 'ERR';

  return (
    <>
      <div onClick={openMenu} style={{ display: 'inline-block', marginLeft: 20 }}>
        <IconButton size="small" color="inherit">
          <ColoredAvatar colored={purple[800]}>{avatarText}</ColoredAvatar>
        </IconButton>
      </div>
      <Popover
        {...popoverOpts}
        TransitionComponent={Fade}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={closeMenu}>
        <ProfileMenuContainer pt={2} px={2} pb={1}>
          <Box mb={1}>
            <ColoredAvatar colored={orange[800]}>{avatarText}</ColoredAvatar>
          </Box>
          <Typography align="center" variant="body2">
            {user ? `${first_name} ${last_name}` : 'Logged Out'}
          </Typography>
          <Typography align="center" color="textSecondary" variant="body2">
            {user ? `${designation}, ${organization}.` : 'Logged Out'}
          </Typography>
          <Typography align="center" color="textSecondary" variant="body2">
            {user ? `${roleId}` : 'Logged Out'}
          </Typography>
        </ProfileMenuContainer>
        <Divider />
        <MenuItem onClick={logout}>
          <CustomListItemIcon>
            <HiLogout color="error" />
          </CustomListItemIcon>
          <ListItemText primary="Logout" primaryTypographyProps={errorTypography} />
        </MenuItem>
      </Popover>
    </>
  );
};

const CustomListItemIcon = withStyles({
  root: {
    minWidth: 35,
  },
})(ListItemIcon);

const ProfileMenuContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const errorTypography = { color: 'error' } as const;

const popoverOpts = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
  transformOrigin: {
    vertical: 'bottom',
    horizontal: 'right',
  },
} as const;
